import { defineStore } from 'pinia'

interface SignalState {
  controller: AbortController
}

export const useSignalStore = defineStore('signal', {
  state: (): SignalState => ({
    controller: new AbortController()
  }),
  actions: {
    abort() {
      this.controller.abort()
      this.controller = new AbortController()
    }
  },
  getters: {
  }
})